export default "__VITE_ASSET__653cb5d0__"